export default "__VITE_ASSET__B936X1N5__"